import script from "./TokenSelectInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./TokenSelectInput.vue?vue&type=script&setup=true&lang=ts"

import "./TokenSelectInput.vue?vue&type=style&index=0&id=75d581a0&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75d581a0"]])

export default __exports__